import styled from 'styled-components'

interface IVendorPaymentMethodSelectStyledProps {}

export const VendorPaymentMethodSelectStyled = styled.div<IVendorPaymentMethodSelectStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
